import {
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  AtSign,
  Bold,
  Building,
  Calendar,
  CalendarClock,
  CalendarDays,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CircleCheck,
  CircleQuestionMark,
  CircleX,
  Crown,
  createIcons,
  Download,
  Eye,
  FileSpreadsheet,
  FileText,
  Flag,
  Globe,
  Goal,
  Heading1,
  Heading2,
  Heading3,
  Info,
  Italic,
  Link,
  List,
  ListOrdered,
  LoaderCircle,
  Mail,
  MapPin,
  Menu,
  MoreVertical,
  Phone,
  Pilcrow,
  Plus,
  Search,
  Settings,
  SquarePen,
  Trash2,
  Trophy,
  Unlink,
  User,
  UserLock,
  UserPen,
  Users,
  X,
} from 'lucide';

export function replaceIcons(root?: HTMLElement) {
  createIcons({
    root,
    icons: {
      AlertTriangle,
      ArrowLeft,
      ArrowRight,
      ArrowUp,
      AtSign,
      Bold,
      Building,
      Calendar,
      CalendarClock,
      CalendarDays,
      ChevronDown,
      ChevronLeft,
      ChevronRight,
      CircleAlert,
      CircleCheck,
      CircleQuestionMark,
      CircleX,
      Crown,
      Download,
      Eye,
      FileSpreadsheet,
      FileText,
      Flag,
      Globe,
      Goal,
      Heading1,
      Heading2,
      Heading3,
      Info,
      Italic,
      Link,
      List,
      ListOrdered,
      LoaderCircle,
      Mail,
      MapPin,
      Menu,
      MoreVertical,
      Phone,
      Pilcrow,
      Plus,
      Search,
      Settings,
      SquarePen,
      Trash2,
      Trophy,
      Unlink,
      User,
      UserLock,
      UserPen,
      Users,
      X,
      CircleCheckFilled: [
        [
          'path',
          {
            d: 'M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.707 9.29297C15.3165 8.90244 14.6835 8.90244 14.293 9.29297L11 12.5859L9.70703 11.293C9.31651 10.9024 8.68349 10.9024 8.29297 11.293C7.90244 11.6835 7.90244 12.3165 8.29297 12.707L10.293 14.707C10.6835 15.0976 11.3165 15.0976 11.707 14.707L15.707 10.707C16.0976 10.3165 16.0976 9.68349 15.707 9.29297Z',
            fill: 'currentColor',
            stroke: 'none',
          },
        ],
      ],
    },
  });
}
